"use client";

import { useEffect } from "react";

import { observer } from "mobx-react-lite";

import { useStore } from "@/store";

import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  /**
   * If set, the original page won't be saved for going back after log in.
   * It will use an already saved redirect back URL if there is one,
   * or go to the root page instead.
   */
  noRedirectBack?: boolean;
};

export const RequireAuth = observer(function RequireAuth({ children, noRedirectBack }: Props) {
  const { auth, signInFlow } = useStore();

  useEffect(() => {
    if (auth.status === "ready" && !auth.isLoggedIn) {
      signInFlow.redirectToLogin(noRedirectBack);
    }
  }, [auth, auth.status, auth.isLoggedIn, noRedirectBack, signInFlow]);

  if (auth.status !== "ready" || !auth.isLoggedIn) {
    return null;
  }

  return children;
});
